


















import Vue, { PropType } from 'vue';

// The pill row behind OrganizationRoleFilterControl.vue and
// PeerGroupRoleFilterControl.vue, which supply the roles and their colors.
export interface RoleFilterOption {
  value: string;
  label: string;
  activeClasses: string[];
}

// ALL matches the greys of PeerGroupSortControl.vue.
const ALL_ACTIVE_CLASSES = [
  'grey',
  'lighten-3',
  'grey--text',
  'text--darken-3'
];
const INACTIVE_PILL_CLASSES = ['grey--text'];

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: 'ALL'
    },
    // The roles, in order; ALL comes first on its own.
    options: {
      type: Array as PropType<RoleFilterOption[]>,
      required: true
    },
    disabled: Boolean
  },

  computed: {
    pills(): {
      value: string;
      label: string;
      active: boolean;
      classes: string[];
    }[] {
      const all: RoleFilterOption = {
        value: 'ALL',
        label: 'All',
        activeClasses: ALL_ACTIVE_CLASSES
      };

      return [all, ...this.options].map(({ value, label, activeClasses }) => {
        const active = this.value === value;

        return {
          value,
          label,
          active,
          classes: active ? activeClasses : INACTIVE_PILL_CLASSES
        };
      });
    }
  },

  methods: {
    // Reselecting the active pill changes nothing; ALL is how to clear.
    select(value: string) {
      if (value !== this.value) {
        this.$emit('change', value);
      }
    }
  }
});
